module.exports = __webpack_public_path__ + "img/Jondras.69ea9cda.jpg";